import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row, Table} from 'reactstrap';
import {
  formsUpdater,
  formsUpdaterIndex,
  getFormFieldValue,
  isValidNumber,
  savePDF,
} from "../Applications/shared/shared";
import {iaArray, stateArray} from "./programInfo";
import {
  calcConsolidatedProgram,
  calcMinPayment,
  calcMinPaymentB,
  calcMonthlyFee,
  calcUp,
  getCashAmount,
  getFSPCost,
  getInsAmount,
  getWord,
  moneyRoundNumber,
  monthDifference,
  printTime,
  safeObject,
  validMinPayment
} from "./calcs";
import {postData} from "../../api/doLogin";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export default class DebtCalc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      formData: {},
      // ourFormData: {},
      calcTotals: {},
      ourCalcTotals: {},
      breakDown: {},
      dataLoaded: true,
      intakeStatus: 0,
      uploadedDocuments: false,
      downloadDocuments: false,
      gotoIntakeUUID: "",
      calendar: [],
      cameras: [],
      calendarList: [],
      defaultCalendar: this.props['loginID'] || 0,
    };
    this.saveForm.bind(this);
  }

  componentDidMount() {
    // this.updateStats();
  }

  saveForm(data, cb) {
    this.setState({formData: data}, cb);
  }

  printForm() {
    let self = this;
    let formData = this.state.formData;
    let calcTotals = this.state.calcTotals;
    let ourCalcTotals = this.state.ourCalcTotals;
    let fspCost = getFSPCost(formData.fsp, formData.age);
    let programFee = calcMonthlyFee(formData.state, Number(ourCalcTotals.payment || 0), formData.debts && formData.debts.length || 0, safeObject(ourCalcTotals, ["balance"], 0), safeObject(ourCalcTotals, ["payoff"], 0));
    let programFeeTotal = programFee * Number(safeObject(ourCalcTotals, ["payoff"], 0));
    const postedData = {
      name: formData.fname,

      totalBalance: 0,
      currentInterestRate: 0,
      currentPayment: calcTotals.payment,
      currentPayoffTime: printTime(calcTotals.payoff || 0),
      currentInterestPaid: moneyRoundNumber(calcTotals.interest || 0),
      currentTotalPaid: moneyRoundNumber(calcTotals.winterest || 0),

      newPayment: moneyRoundNumber(Number(ourCalcTotals.payment || 0) + fspCost + programFee),
      newPayoffTime: printTime(ourCalcTotals.payoff || 0),
      newInterestPaid: moneyRoundNumber(Number(ourCalcTotals.interest || 0) + programFeeTotal),
      newTotalPaid: moneyRoundNumber(Number(ourCalcTotals.winterest || 0) + programFeeTotal),

      analysisTimeWord: getWord(safeObject(calcTotals, ["payoff"], -1) < safeObject(ourCalcTotals, ["payoff"], -1), "Extension", "Savings"),
      analysisTimeSavings: printTime(Math.abs(monthDifference(safeObject(calcTotals, ["payoff"], 0), safeObject(ourCalcTotals, ["payoff"], 0)))),
      analysisInterestSavings: moneyRoundNumber(safeObject(calcTotals, ["interest"], 0) - safeObject(ourCalcTotals, ["interest"], 0) - programFeeTotal),
      analysisInsuranceProtection: moneyRoundNumber(getInsAmount(formData.fsp, formData.age)),
      analysisCashAccumulation: moneyRoundNumber(getCashAmount(formData.fsp, ourCalcTotals.payoff)),

    };
    formData.debts && formData.debts.forEach((debt) => {
      postedData.totalBalance += Number(debt.balance);
      postedData.currentInterestRate += Number(debt.rate);
    });
    postedData.currentInterestRate = moneyRoundNumber(postedData.currentInterestRate / (formData.debts && formData.debts.length || 1));
    postedData.analysisTotalBenefit = moneyRoundNumber(Number(postedData.analysisCashAccumulation) + Number(postedData.analysisInterestSavings));
    postedData.totalBalance = moneyRoundNumber(postedData.totalBalance);

    postData("debtcalc/save", postedData, this.props.token)
      .then((data) => {
        let uint8Array = new Uint8Array(data.data.content.data);
        savePDF(uint8Array);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    let values = this.state.formData;
    let showCalculate = true;
    let ourShowCalculate = true;
    let calcTotals = this.state.calcTotals;
    let ourCalcTotals = this.state.ourCalcTotals;
    let programFee = calcMonthlyFee(values.state, Number(ourCalcTotals.payment || 0), values.debts && values.debts.length || 0, safeObject(ourCalcTotals, ["balance"], 0), safeObject(ourCalcTotals, ["payoff"], 0));
    let programFeeTotal = programFee * safeObject(ourCalcTotals, ["payoff"], 0);
    let cashAccumulation = getCashAmount(values.fsp, ourCalcTotals.payoff);
    let interestSavings = safeObject(calcTotals, ["interest"], 0) - safeObject(ourCalcTotals, ["interest"], 0) - (programFeeTotal);
    let timeSavings = monthDifference(safeObject(calcTotals, ["payoff"], 0), safeObject(ourCalcTotals, ["payoff"], 0));
    let timeWord = getWord(safeObject(calcTotals, ["payoff"], -1) < safeObject(ourCalcTotals, ["payoff"], -1), "Extension", "Savings");
    let insAmount = getInsAmount(values.fsp, values.age);
    let fspCost = getFSPCost(values.fsp, values.age);
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Fragment>

            <Card>
              <CardHeader>
                <strong>Debt Calculator</strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={"3"}>
                    <FormGroup>
                      <Label htmlFor="fname">Name*</Label>
                      <Input type="text" id="fname" placeholder=""
                             value={getFormFieldValue(values.fname)}
                             onChange={(evt) => formsUpdater(evt, values, this)}/>
                    </FormGroup>
                  </Col>
                  <Col xs={"3"}>
                    <FormGroup>
                      <Label htmlFor="state">State*</Label>
                      <Input type="select" name={"state"} id={"state"}
                             value={getFormFieldValue(values.state)}
                             onChange={(evt) => formsUpdater(evt, values, this)}>
                        <option key={0} value={""} disabled={true}>Choose</option>
                        {Object.keys(stateArray).map((value, index) => {
                          return (
                            <option key={index + 1} value={value}>{value}</option>
                          )
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col xs={"3"}>
                    <FormGroup>
                      <Label htmlFor="age">Age*</Label>
                      <Input type="select" name={"age"} id={"age"}
                             value={getFormFieldValue(values.age)}
                             onChange={(evt) => formsUpdater(evt, values, this)}>
                        <option key={0} value={""} disabled={true}>Choose</option>
                        {Array.from(Array(31), (_, i) => i + 18).map((value, index) => {
                          return (
                            <option key={index + 1} value={value}>{value}</option>
                          )
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <p>Input Credit card balances below, then press Calculate:</p>

                <Table>
                  <thead>
                  <tr style={{fontWeight: "bold"}}>
                    <td>Debt Name</td>
                    <td>Balance</td>
                    <td>% Rate</td>
                    <td>Payment</td>
                    <td/>
                  </tr>
                  </thead>
                  <tbody>
                  {values.debts && values.debts.map((debt, index) => {
                    if (!isValidNumber(debt.balance) || !isValidNumber(debt.rate) || !isValidNumber(debt.payment)) {
                      showCalculate = false;
                    }
                    return <tr key={index}>
                      <td>
                        <FormGroup>
                          <Input type="text" id="display" placeholder=""
                                 value={getFormFieldValue(debt.display)}
                                 onChange={(evt) => formsUpdaterIndex("debts", index, evt, values, this)}/>
                        </FormGroup>
                      </td>
                      <td>
                        <FormGroup>
                          <Input type="text" id="balance" placeholder=""
                                 value={getFormFieldValue(debt.balance)}
                                 valid={isValidNumber(debt.balance)}
                                 onChange={(evt) => formsUpdaterIndex("debts", index, evt, values, this)}
                                 onBlur={() => {
                                   console.log("blurred");
                                   const mPayment = calcMinPayment(debt.balance, debt.rate);
                                   if (!!mPayment) {
                                     formsUpdaterIndex("debts", index, {
                                       target: {
                                         id: "payment",
                                         value: mPayment
                                       }
                                     }, values, this)
                                   }
                                 }}
                          />
                        </FormGroup>
                      </td>
                      <td>
                        <FormGroup>
                          <Input type="text" id="rate" placeholder=""
                                 value={getFormFieldValue(debt.rate)}
                                 valid={isValidNumber(debt.rate)}
                                 onChange={(evt) => formsUpdaterIndex("debts", index, evt, values, this)}
                                 onBlur={() => {
                                   console.log("blurred");
                                   const mPayment = calcMinPayment(debt.balance, debt.rate);
                                   if (!!mPayment) {
                                     formsUpdaterIndex("debts", index, {
                                       target: {
                                         id: "payment",
                                         value: mPayment
                                       }
                                     }, values, this)
                                   }
                                 }}
                          />
                        </FormGroup>
                      </td>
                      <td>
                        <FormGroup>
                          <Input type="text" id="payment" placeholder=""
                                 value={getFormFieldValue(debt.payment)}
                                 valid={isValidNumber(debt.payment)}
                                 onChange={(evt) => formsUpdaterIndex("debts", index, evt, values, this)}
                                 onBlur={() => {
                                 }}
                          />
                          {isValidNumber(debt.payment) && validMinPayment(debt.balance, debt.rate, debt.payment) === false && (
                            <span>Less than interest rate</span>
                          )}
                        </FormGroup>
                      </td>
                      <td>
                        <Button onClick={() => {
                          const newForm = {
                            ...values,
                            debts: values.debts.filter((debt, i) => i !== index)
                          }
                          this.setState({formData: newForm});
                        }}>Remove</Button>
                      </td>
                    </tr>
                  })
                  }

                  </tbody>
                  <tfoot>
                  <tr>
                    <td>
                      <Button onClick={() => {
                        const newForm = {
                          ...values,
                          debts: values.debts ? values.debts.concat({}) : [{}]
                        }
                        this.setState({formData: newForm});
                      }}>Add</Button>
                    </td>
                    <td colSpan={3}>
                      &nbsp;
                    </td>
                    <td>
                      {values.debts && values.debts.length > 0 && showCalculate && (
                        <Button onClick={() => {
                          const ourSnapshot = values.ourProgram || [];
                          this.setState({
                            showBreakDown: true,
                            calcTotals: calcUp(values.debts),
                            formData: {
                              ...values,
                              ourProgram: values.debts.map((debt, index) => {
                                if (ourSnapshot[index]) {
                                  return {
                                    ...debt,
                                    rate: ourSnapshot[index].rate || "",
                                    payment: ourSnapshot[index].payment || ""
                                  }
                                } else {
                                  return {
                                    ...debt,
                                    rate: "",
                                    payment: ""
                                  }
                                }
                              })
                            }
                          });
                        }}>Calculate</Button>
                      )}
                    </td>
                  </tr>
                  </tfoot>
                </Table>

                <Row>
                  <Col xs={3}>
                    Total Balances:<br/>${this.state.calcTotals.balance || "0.00"}
                  </Col>
                  <Col xs={3}>
                    Total Monthly Payment:<br/>${this.state.calcTotals.payment || "0.00"}
                  </Col>
                </Row>

                <Row>
                  <Col xs={3}>
                    Total With Interest:<br/>${this.state.calcTotals.winterest || "0.00"}
                  </Col>
                  <Col xs={3}>
                    Payoff Time:<br/>{printTime(this.state.calcTotals.payoff || 0)}
                  </Col>
                </Row>

              </CardBody>
            </Card>
            {this.state.showBreakDown && (

              <Card>
                <CardHeader>
                  <strong>Our Debt Relief Program</strong>
                </CardHeader>
                <CardBody>
                  <Table>
                    <thead>
                    <tr style={{fontWeight: "bold"}}>
                      <td>Debt Name</td>
                      <td>Balance</td>
                      <td>% Rate</td>
                      <td>Payment</td>
                    </tr>
                    </thead>
                    <tbody>
                    {values.ourProgram && values.ourProgram.map((debt, index) => {
                      if (!isValidNumber(debt.balance) || !isValidNumber(debt.rate) || !isValidNumber(debt.payment)) {
                        ourShowCalculate = false;
                      }
                      return <tr key={index}>
                        <td>
                          <FormGroup>
                            <Input type="text" id="display" placeholder=""
                                   value={getFormFieldValue(debt.display)}
                                   disabled={true}
                                   onChange={(evt) => formsUpdaterIndex("debts", index, evt, values, this)}/>
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <Input type="text" id="balance" placeholder=""
                                   value={getFormFieldValue(debt.balance)}
                                   valid={isValidNumber(debt.balance)}
                                   disabled={true}
                                   onChange={(evt) => formsUpdaterIndex("debts", index, evt, values, this)}
                                   onBlur={() => {
                                     console.log("blurred");
                                     const mPayment = calcMinPaymentB(debt.balance, debt.rate);
                                     if (!!mPayment) {
                                       formsUpdaterIndex("debts", index, {
                                         target: {
                                           id: "payment",
                                           value: mPayment
                                         }
                                       }, values, this)
                                     }
                                   }}
                            />
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <Input type="text" id="rate" placeholder=""
                                   value={getFormFieldValue(debt.rate)}
                                   valid={isValidNumber(debt.rate)}
                                   onChange={(evt) => formsUpdaterIndex("ourProgram", index, evt, values, this)}
                                   onBlur={() => {
                                     console.log("blurred");
                                     const mPayment = calcMinPaymentB(debt.balance, debt.rate);
                                     if (!!mPayment) {
                                       formsUpdaterIndex("ourProgram", index, {
                                         target: {
                                           id: "payment",
                                           value: mPayment
                                         }
                                       }, values, this)
                                     }
                                   }}
                            />
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <Input type="text" id="payment" placeholder=""
                                   value={getFormFieldValue(debt.payment)}
                                   valid={isValidNumber(debt.payment)}
                                   onChange={(evt) => formsUpdaterIndex("ourProgram", index, evt, values, this)}
                                   onBlur={() => {
                                   }}
                            />
                            {isValidNumber(debt.payment) && validMinPayment(debt.balance, debt.rate, debt.payment) === false && (
                              <span>Less than interest rate</span>
                            )}
                          </FormGroup>
                        </td>
                      </tr>
                    })
                    }

                    </tbody>
                    <tfoot>
                    <tr>
                      <td colSpan={3}>
                        &nbsp;
                      </td>
                      <td>
                        {values.ourProgram && values.ourProgram.length > 0 && ourShowCalculate && (
                          <Button onClick={() => {

                            this.setState({
                              showBreakDown: true,
                              ourCalcTotals: calcConsolidatedProgram(values.ourProgram),
                            });
                          }}>Calculate</Button>
                        )}
                      </td>
                    </tr>
                    </tfoot>
                  </Table>

                  <Row>
                    <Col xs={3}>
                      Total Balances:<br/>${this.state.ourCalcTotals.balance || "0.00"}
                    </Col>
                    <Col xs={3}>
                      Total Monthly
                      Payment:<br/>${moneyRoundNumber(Number(this.state.ourCalcTotals.payment || 0) + fspCost + programFee)}
                      {(fspCost > 0 || programFee > 0) && (
                        <Fragment>
                          <br/>
                          <span style={{fontSize: 8}}>
                          &nbsp;(${moneyRoundNumber(Number(this.state.ourCalcTotals.payment || 0))}
                            {programFee > 0 && (
                              <Fragment>
                                &nbsp;+ ${moneyRoundNumber(programFee)} prgm fee
                              </Fragment>
                            )}
                            {fspCost > 0 && (
                              <Fragment>
                                &nbsp;+ ${moneyRoundNumber(fspCost)} FSP
                              </Fragment>
                            )}
                            )
                        </span>
                        </Fragment>
                      )}

                    </Col>
                  </Row>

                  <Row>
                    <Col xs={3}>
                      Total With
                      Interest:<br/>${moneyRoundNumber((Number(this.state.ourCalcTotals.winterest || 0)) + (programFee * Number(this.state.ourCalcTotals.payoff || 0)))}
                    </Col>
                    <Col xs={3}>
                      Payoff Time:<br/>{printTime(this.state.ourCalcTotals.payoff || 0)}
                    </Col>
                  </Row>

                  <div style={{
                    width: "805",
                    marginRight: "auto",
                    marginLeft: "auto",
                    marginTop: 50,
                    fontSize: 14,
                    fontWeight: "bolder"
                  }}>
                    Additional Options:
                  </div>

                  <Row>
                    <Col xs={6}>
                      <FormGroup>
                        <Label htmlFor="fsp">Financial Security Provider</Label>
                        <Input type="select" name={"fsp"} id={"fsp"}
                               value={getFormFieldValue(values.fsp)}
                               onChange={(evt) => formsUpdater(evt, values, this)}>
                          <option key={0} value={""} disabled={true}>Choose</option>
                          {iaArray.map((value, index) => {
                            return (
                              <option key={index + 1} value={index}>{value.display}</option>
                            )
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={3}>
                      Time {timeWord}:
                      <br/>
                      {printTime(timeSavings)}
                    </Col>
                    <Col xs={3}>
                      Interest Savings:
                      <br/>
                      ${moneyRoundNumber(interestSavings)}
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={3}>
                      Insurance Protection:
                      <br/>
                      ${moneyRoundNumber(insAmount)}
                    </Col>
                    <Col xs={3}>
                      Cash
                      Accumulation:<br/>${moneyRoundNumber(cashAccumulation)}
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={6} style={{textAlign: "center", fontWeight: "bold"}}>
                      Total Benefit:<br/>${moneyRoundNumber(interestSavings + cashAccumulation)}<br/><br/>
                      {showCalculate && ourShowCalculate && !!ourCalcTotals.payment && (
                        <Button onClick={() => this.printForm()}>Print Form</Button>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}

          </Fragment>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/DebtCalc/DebtCalc.js